import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import dayjs from 'dayjs';
import type { WeekSelectorProps } from './riego.types';

const getWeekRange = (startDate: dayjs.Dayjs) => {
  const start = startDate.startOf('week').add(1, 'day'); // Lunes
  const end = start.add(6, 'day');
  return {
    start,
    end,
    label: `Semana ${start.format('DD/MM')} - ${end.format('DD/MM')}`,
  };
};

const WeekSelector: React.FC<WeekSelectorProps> = ({ onChange }) => {
  const [offset, setOffset] = useState(0); // 0 = semana actual centrada
  const today = dayjs();
  const currentMonday = today.startOf('week').add(1, 'day');
  const weeks = [-1, 0, 1].map((i) => getWeekRange(currentMonday.add(offset + i, 'week')));
  const [selected, setSelected] = useState(1); // 0: izquierda, 1: centro, 2: derecha

  const handleSelect = (idx: number) => {
    setSelected(idx);
    onChange(weeks[idx]);
  };

  const handlePrev = () => {
    const newOffset = offset - 1;
    setOffset(newOffset);
    const newWeeks = [-1, 0, 1].map(
      (i) => getWeekRange(currentMonday.add(newOffset + i, 'week')),
    );
    onChange(newWeeks[selected]);
  };

  const handleNext = () => {
    const newOffset = offset + 1;
    setOffset(newOffset);
    const newWeeks = [-1, 0, 1].map(
      (i) => getWeekRange(currentMonday.add(newOffset + i, 'week')),
    );
    onChange(newWeeks[selected]);
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center" width="100%">
      <IconButton onClick={handlePrev}>
        <ArrowBackIosIcon />
      </IconButton>
      {weeks.map((week, idx) => (
        <Box
          key={week.label}
          onClick={() => handleSelect(idx)}
          sx={{
            flex: 1,
            textAlign: 'center',
            cursor: 'pointer',
            background: selected === idx ? '#e3f2fd' : 'white',
            border: '1px solid #e0e0e0',
            padding: 2,
            fontWeight: selected === idx ? 'bold' : 'normal',
          }}
        >
          <Typography>{week.label}</Typography>
        </Box>
      ))}
      <IconButton onClick={handleNext}>
        <ArrowForwardIosIcon />
      </IconButton>
    </Box>
  );
};

export default WeekSelector;
